export default {"src":"/_next/static/image/public/images/ic_radio_normal.397e8073fed6d6621c3c67e0bc625f3e.svg","height":24,"width":24};